<template lang="pug">
  transition(name="fade")
    .common-image-popup(
      v-if="visible && imgLoaded"
      v-scroll-lock="visible"
      @click.self="handleClose"
    )
      .popup-content
        //- 弹窗图片
        img.popup-img(:src="info.popupWindowImage" @click="handleImageClick")
        //- 关闭按钮
        .close-btn(@click="handleClose")
</template>

<script>
import { jumpUrl } from '@/utils/tools';
import SPM from '../../common/spm';
import { anchorToModule } from '../../common/helper';

export default {
  name: 'CommonImagePopup',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      imgLoaded: false,
      anchorTimer: null,
    };
  },
  watch: {
    'info.popupWindowImage': {
      immediate: true,
      handler(url) {
        if (!url) return;
        const img = new Image();
        img.onload = () => {
          this.imgLoaded = true;
          if (this.visible) {
            this.$nextTick(() => this.handleExpose());
          }
        };
        img.src = url;
      },
    },
    visible(val) {
      if (val && this.imgLoaded) {
        this.$nextTick(() => this.handleExpose());
      }
    },
  },
  methods: {
    handleExpose() {
      SPM.moduleExpose({
        moduleId: 'platform_popoup_common',
        contentId: 'platform_popoup_common',
        businessInfo: {
          url: this.info.jumpType ? this.info.jumpUrl || '' : this.info.anchoring || '',
          strategyName: this.info.strategyName,
          code: this.info.strategyId,
        },
      });
    },
    // 点击图片
    handleImageClick() {
      const { jumpType, jumpUrl: url, anchoring } = this.info;
      this.$emit('close');

      SPM.clickButton({
        buttonName: 'platform_popoup_common',
        businessInfo: {
          url: this.info.jumpType ? this.info.jumpUrl || '' : this.info.anchoring || '',
          strategyName: this.info.strategyName,
          code: this.info.strategyId,
        },
      });
      if (jumpType) {
        // 支持跳转 → 跳转链接
        if (url) jumpUrl(url);
      } else if (anchoring) {
        // 不支持跳转 → 锚定到指定模块
        this.$nextTick(() => {
          this.anchorTimer = anchorToModule(
            { anchoringModuleKey: anchoring },
            this.anchorTimer,
          );
        });
      }
    },
    // 关闭弹窗
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.common-image-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .popup-content {
    position: relative;
    width: 2.97rem;

    .popup-img {
      display: block;
      width: 100%;
      height: auto;
    }

    .close-btn {
      margin: 0.3rem auto 0;
      width: 0.32rem;
      height: 0.32rem;
      background: url('https://m.hellobike.com/resource/gallery/833/dRaJxJTBwm.png') no-repeat center / contain;
    }
  }
}

// 过渡动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
